import React, { Component } from 'react';
import reduxStore from './../../../reduxStore';
import { FormattedMessage } from 'react-intl';
import categoriesApi from './../../../api/Categories.api';
import popupActions from '../../../reusable/MessagePopup/redux/MessagePopup.actions';
import { ModalImpendingDeletion } from '../../../reusable/Modal/ModalBodies';
import { POPUP_LIFETIME } from '../../../constants';
import utils from '../../../utils/utilities';

export default class ImpendingCategoryDeletion extends Component {
    constructor() {
        super();
        this.state = {
            userHasEmptyCategories: false,
            countdown:              null,
            modalImpendingDeletion: false,
            isModalLoading:         false
        };

        this.categoryCountdownStartTimestamp = reduxStore.getState().user.categoryCountdownStartTimestamp;
        this.minutesToCategoryDeletion = reduxStore.getState().user.appSettings.minutesToCategoryDeletion;

        this.getEmptyCategoriesCount = this.getEmptyCategoriesCount.bind(this);
        this.deleteAllEmptyCategories = this.deleteAllEmptyCategories.bind(this);
        this.resetImpendingCategoryDeletion = this.resetImpendingCategoryDeletion.bind(this);

        this.toggleModalImpendingDeletion = this.toggleModalImpendingDeletion.bind(this);
        this.showSuccessPopup = this.showSuccessPopup.bind(this);
        this.showFailurePopup = this.showFailurePopup.bind(this);
    }

    componentDidMount() {
        this.getEmptyCategoriesCount();
    }

    getEmptyCategoriesCount() {
        categoriesApi.getEmptyCategoriesCount()
            .then((response) => {
                if (!!response.body) {
                    this.generateDaysCounter();
                    this.setState({
                        countdown:              this.generateDaysCounter(),
                        userHasEmptyCategories: !!response.body
                    });
                }
            }).catch((error) => {
            utils.logError(error, 'ManageCategoriesPage - categoriesApi.getEmptyCategoriesCount(): failure');
        });
    }

    generateDaysCounter() {
        let impendingDeletionDays = this.minutesToCategoryDeletion / 24 / 60;
        if (!this.categoryCountdownStartTimestamp) {
            return impendingDeletionDays;
        }
        let now           = new Date(),
            nowInMs       = now.getTime(),
            timeElapsedMs = nowInMs - this.categoryCountdownStartTimestamp,
            daysElapsed   = Math.floor(timeElapsedMs / (24 * 60 * 60 * 1000));
        return impendingDeletionDays - daysElapsed;
    }

    deleteAllEmptyCategories() {

        this.setState({isModalLoading: true});
        categoriesApi.getEmpty()
            .then((response) => {
                if (response.body.length === 0) {
                    this.toggleModalImpendingDeletion();
                    this.setState({
                        isModalLoading:         false,
                        userHasEmptyCategories: false
                    });
                    this.showSuccessPopup('Category_Manage_UIText_deleteAllEmptyCategories.successMessage');
                    return;
                }
                let categoriesArr = [];
                for (let i = 0; i < response.body.length; i++) {
                    categoriesArr.push(response.body[i].id)
                }
                categoriesApi.deleteCategories(categoriesArr)
                    .then((response) => {
                        this.toggleModalImpendingDeletion();
                        this.setState({
                            isModalLoading:         false,
                            userHasEmptyCategories: false
                        });
                        this.showSuccessPopup('Category_Manage_UIText_deleteAllEmptyCategories.successMessage');
                        this.getEmptyCategoriesCount();
                    });
            })
            .catch((error) => {
                this.toggleModalImpendingDeletion();
                this.showFailurePopup('General_CoreFunctionality_UIText_general.genericErrorMsg');
            });
    }

    toggleModalImpendingDeletion() {
        this.setState({modalImpendingDeletion: !this.state.modalImpendingDeletion})
    }

    showSuccessPopup(messageId) {
        popupActions.setMessages({
            popupTitle: null,
            messages: [
                {
                    messageId: messageId,
                    messageType: 'success'
                }
            ]
        });

        // Hide the message after 5 seconds.
        setTimeout(popupActions.removeMessage, POPUP_LIFETIME);
    }

    showFailurePopup(messageId) {
        popupActions.setMessages({
            popupTitle: null,
            messages: [
                {
                    messageId: messageId,
                    messageType: 'system-error'
                }
            ]
        });

        // Hide the message after 5 seconds.
        setTimeout(popupActions.removeMessage, POPUP_LIFETIME);
    }

    resetImpendingCategoryDeletion() {
        this.setState({
            userHasEmptyCategories: false,
            modalImpendingDeletion: false
        });
    }

    render() {

        return (
            <div className='impending-category-deletion'>

                {
                    this.state.userHasEmptyCategories && this.state.countdown >= 0 ?
                        <div className='impending-categories-deletion-notification'>
                            <div className='container'>
                                <span className='message'>
                                    <FormattedMessage id='Category_Manage_UIText_impendingDeletionWarning.message1_1'/> <b><span>{this.state.countdown}</span> <FormattedMessage id='Category_Manage_UIText_impendingDeletionWarning.message1_2'/></b> <FormattedMessage id='Category_Manage_UIText_impendingDeletionWarning.message1_3'/>
                                    &nbsp;
                                    <span className='edit-delete'
                                          onClick={this.toggleModalImpendingDeletion}>
                                        <FormattedMessage id='Category_Manage_UIText_impendingDeletionWarning.modalLink'/>
                                    </span>
                                </span>
                            </div>
                        </div>
                        :
                        null
                }

                {
                    this.state.modalImpendingDeletion ?
                        <ModalImpendingDeletion
                            isModalLoading={this.state.isModalLoading}
                            primaryAction={this.deleteAllEmptyCategories}
                            primaryI18n={"Category_Manage_UIText_impendingDeletionModal.primaryButton"}
                            secondaryAction={this.toggleModalImpendingDeletion}
                            resetImpendingCategoryDeletion={this.resetImpendingCategoryDeletion} />
                        :
                        null
                }

            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/scripts/pages/Categories/Components/ImpendingCategoryDeletion.jsx